<div class="row">
  <div class="col-md-4 col-sm-4 ">
    <label class="font-weight-bold">{{'reservation.name' | translate}}</label><br/>
    <span>{{reservation.billingData.lastName + ' ' + reservation.billingData.firstName }}</span>
  </div>
  <div class="col-md-4 col-sm-4">
    <label class="font-weight-bold">{{'reservation.phone' | translate}}</label><br/>
    <span>{{reservation.billingData.phoneNumber}}</span>
  </div>
  <div class="col-md-4 col-sm-4 ">
    <label class="font-weight-bold">{{'reservation.status' | translate}} </label><br/>
    <span>{{'reservation.state.' + reservation.reservationStatus | translate}}</span>
  </div>

</div>
